export class InviteToOrganization {
  public static readonly type = "[Organizations] Invite to Organization";
  public constructor(public emails: string[]) {}
}
